



export enum ConsoleCode {
    kec = 'kec',
    kce = 'kce',
    as = 'as'
}



